import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

export interface AddAccountParameter {
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    isSubscribed: boolean;
    onSuccess?: (account?: AccountModel) => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    AddAccountParameter,
    AddAccountApiParameter,
    ServiceResult<AccountModel>,
    { currentUserIsGuest?: boolean }
>;

export const PopulateApiParameterUpdated: HandlerType = props => {
    props.apiParameter = {
        account: {
            ...props.parameter,
        } as AccountModel,
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterUpdated);
